/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ManagementIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 32 32"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M2.875,20.5 L2.875,28 L29.125,28 L29.125,20.5 L30.375,20.5 L30.375,10.5 C30.375,9.12 29.255,8 27.875,8 L4.125,8 C2.745,8 1.625,9.12 1.625,10.5 L1.625,20.5 L2.875,20.5 Z" />
      <rect x="12.875" y="18" width="6.25" height="3.75" />
      <path d="M21.625,8 L10.375,8 L10.375,6.75 C10.375,4.68 12.055,3 14.125,3 L17.875,3 C19.94625,3 21.625,4.68 21.625,6.75 L21.625,8 Z" />
      <path d="M2.875,20.5 L12.875,20.5" />
      <path d="M19.125,20.5 L29.125,20.5" />
    </g>
  </svg>
);

export default ManagementIcon;
